import { CostCenterDetail } from '../types';

import { Option } from 'components/shared/ControlledFields/ControlledSelect';
import dayjs from 'dayjs';
import { formatCostCenterDetailLabel } from '../components/form/utils/utils';

const useCreateCostCenterDetailOptions = (
  costCenterDetails?: CostCenterDetail[]
) => {
  if (!costCenterDetails || costCenterDetails.length === 0) {
    return [];
  }

  return costCenterDetails.map((item) => {
    return {
      value: item.brDynId,
      label: formatCostCenterDetailLabel(item),
      validFrom: dayjs(item.valid.from).isValid()
        ? dayjs(item.valid.from).valueOf()
        : -1
    };
  }) as (Option & { validFrom: number })[];
};

export default useCreateCostCenterDetailOptions;
